import Schema from "AppReact/schema";
import { required, optional } from 'AppReact/schema';

const worker = {
  id: required('integer'),
  name: required('string'),
  icon: optional('string')
}

export default {
  left: Schema("integer", "primitive", { defaultValue: 0 }),
  workers: Schema(worker, 'array', { defaultValue: [] }),
  selectedWorkerIds: Schema('integer', 'array', { defaultValue: [] }),
  searchTerm: Schema("string", "primitive", { defaultValue: '' }),
  label: Schema("string", "primitive", { defaultValue: '' }),
  isOpen: Schema("boolean", "primitive", { defaultValue: false }),
  isSingleSelect: Schema("boolean", "primitive", { defaultValue: false }),
};
